fx.ns("desktop.common.panels", class CheckBookPanel extends fx.components.PopupPanel {

    constructor(data)
    {
        super(data);

		this.destroyOnSwitch = true;
        this.contentWidth = 610;
        this.contentHeight = 550;
        //this.showClose = !fx.get("previewMode");

        this.mode = fx.get("previewMode") ? "navigation" : "popup";
    }
  
    create()
    {
        super.create();

		let mainbox = new fx.components.Box("container");

        // header
        mainbox.addChild(new shared.component.Person(fx.get("assets").personAdvice), {width:200, height : 200, left : "center"});
        mainbox.addChild(new fx.components.Image({data: fx.assets.warningIcon, className: "warning"}), {width:20, height : 20, top : 170, left : "center"});
        mainbox.addChild(new fx.components.Text({text:fx.text("J'ai vérifié votre album, et j'ai constaté cela :"), className:"title medium center bold"}), {left:0, top:200, width:"100%"});
        
        // reports
        this.container = new fx.components.Box("report-content-container");
        let box = new fx.components.VBox("report-content");
        let fullreport = this.data.report();
        for (let i = 0; i < fullreport.pages.length; i++)
        {
            let reportBox = new fx.components.HBox("report");
            let report = fullreport.pages[i];
            let pageText =  (report.page.isCover ? fx.text("Couverture") : (fx.text("Page") + " " + report.page.label(undefined, "-")));
            reportBox.addChild(new fx.components.Text(fx.text("- La ")));
            let link = new fx.components.LinkButton({label : pageText});
            link.attr("page-id", report.page.id);
            link.toolTip =  fx.text("Cliquez pour aller à la page") + " " + report.page.label();
            reportBox.addChild(link);

            if (report.empty)
                reportBox.addChild(new fx.components.Text(" " + fx.text("est vide")));
            else
            if (report.components.length > 0)
                reportBox.addChild(new fx.components.Text(fx.text((report.components.length == 1) ? "contient une zone photo vide" : "contient $ zones photo vides") , [report.components.length]));

            box.addChild(reportBox, {height: 25, width : "100%"});
        }

        if( !fullreport.isMultipleOf4)
        {
            box.addChild(new fx.components.Text({text: fx.text("- Votre album ne contient pas un nombre de pages multiple de 4.")}));
            box.addChild(new fx.components.Text({text: fx.text("Une feuille sera donc ajoutée à la fin de votre ouvrage au moment de la fabrication."), className: "pageAddText2"}));
        }
        
        this.container.addChild(box, {top : 0, left : 0, width : "100%"})
        mainbox.addChild(this.container, {top : 245, left : "center", height : 175, width: "100%"})
        
        // footer
        mainbox.addChild(new fx.components.Text({text:fx.text("Souhaitez-vous commander votre ouvrage dans l'état ?"), className:"question text"}), {left:0, top:440, width:"100%"});
        let hbox = new fx.components.HBox();
        this.cancelButton = new fx.components.Button( fx.get("previewMode") ? fx.text("Corriger") : fx.text("Annuler"));
        this.cancelButton.attr("data-testid", "checkbook-cancel");
        
        this.continueButton = new fx.components.Button({label : fx.text( "Commander" ), type : "filled"});
        this.continueButton.attr("data-testid", "checkbook-order");

        hbox.addChild(this.cancelButton, {width : 200});
        hbox.addChild(this.continueButton, {width : 200});
        mainbox.addChild(hbox, {top: 480, left : "center"});

        this.addChild(mainbox, { top: "center", left: "center", height: 550, width: 600 })
    }

    onReady()
    {
        super.onReady();

        this.on("click", this._onContinue, this.continueButton);
        this.on("click", this.close, this.cancelButton);
        this.on("click", this._onPageClick);
    }

    close()
    {
		super.close();
		this.data.event("show-editor");
    }

    _onContinue()
    {
        //this.data.bookChecked = true;
        this.hideEffect = "hslidein";
        this.data.event("check-creation-confirmed");
    }

    _onPageClick(e)
    {
        let link = fx.dom.parent(e.target, ".LinkButton");
        if (!link)
            return;
        this.data.creation.event("select-page", link.getAttribute("page-id"));
        this.close()

    }

  


});